(function($) {
  'use strict';

  $('.js-filter-title button').click(function(event) {
    event.preventDefault();
    var $filterTitle = $(this).closest('.js-filter-title'),
      $filterContent = $filterTitle.siblings('.js-filter-content');

    if ($filterTitle.hasClass('active')) {
      $filterTitle.removeClass('active');
      $filterContent.slideUp(300, function() {
        $filterContent.removeClass('active').removeAttr('style');
      });
    } else {
      $filterTitle.addClass('active');
      $filterContent.slideDown(300, function() {
        $filterContent.addClass('active').removeAttr('style');
      });
    }
  });

  if ($('.js-filter-radiobuttons').length) {
    $('.js-filter-radiobuttons').each(function() {
      var $radioButtonsBlock = $(this),
        $radioButtons = $radioButtonsBlock.find('input[type="radio"]'),
        $datePicker = $radioButtonsBlock.closest('form').find('.js-datepicker');

      $radioButtons.click(function() {
        var $radioButton = $(this);

        if ($radioButton.hasClass('checked')) {
          $radioButton.prop('checked', false);
          $radioButton.removeClass('checked');

          if ($('#queries_date_range_query').length) {
            $('#queries_date_range_query').val('');
          }
        } else {
          $radioButtons.removeClass('checked');
          $radioButton.addClass('checked');

          setSearchDateField($radioButton.val());

          if ($datePicker.length) {
            $('.js-datepicker').removeClass('ui-datepicker-ready');
            $('.js-datepicker').datepicker('setDate', null);
            $('.js-datepicker')
              .find('.ui-state-active')
              .removeClass('ui-state-active');
            $('.js-datepicker').addClass('ui-datepicker-ready');
          }
        }
      });
    });
  }

  function setSearchDateField(dateRange) {
    dateRange = parseInt(dateRange);
    if ($('#queries_date_range_query').length) {
      if (dateRange == 1 || dateRange == 3) {
        var d1 = new Date();
        var startDay = d1.getDate(),
          startMonth = d1.getMonth(),
          startYear = d1.getFullYear();

        var startDate = new Date(startYear, startMonth, startDay);

        var d2 = new Date();
        d2.setDate(d2.getDate() + dateRange);

        var endDay = d2.getDate(),
          endMonth = d2.getMonth(),
          endYear = d2.getFullYear();
        var endDate = new Date(endYear, endMonth, endDay);
      } else if (dateRange == 7) {
        var startAndend = getNextWeek();
        var startDate = startAndend.start,
          endDate = startAndend.end;
      } else if (dateRange == 30) {
        var startAndend = getNextMonth();
        var startDate = startAndend.start,
          endDate = startAndend.end;
      }

      var dates = [];
      dates = getDates(startDate, endDate, dateRange).join('|');

      $('#queries_date_range_query').val(dates);
    }
  }

  function getNextWeek() {
    var nextMonday = moment()
      .add(1, 'weeks')
      .startOf('isoWeek');
    var nextSunday = moment()
      .add(1, 'weeks')
      .endOf('isoWeek');

    var startDay = nextMonday.format('DD'),
      startMonth = parseInt(nextMonday.format('MM')) - 1,
      startYear = nextMonday.format('YYYY');

    var endDay = nextSunday.format('DD'),
      endMonth = parseInt(nextSunday.format('MM')) - 1,
      endYear = nextSunday.format('YYYY');

    var startDate = new Date(startYear, startMonth, startDay);
    var endDate = new Date(endYear, endMonth, endDay);

    return {
      start: startDate,
      end: endDate,
    };
  }

  function getNextMonth() {
    var d = new Date();
    var startDate = '';
    if (d.getMonth() == 11) {
      startDate = moment([d.getFullYear() + 1, 0]).toDate();
    } else {
      startDate = moment([d.getFullYear(), d.getMonth() + 1]).toDate();
    }

    var endDate = moment(startDate)
      .endOf('month')
      .toDate();

    return {
      start: startDate,
      end: endDate,
    };
  }

  function getDates(start, end, dateRange) {
    var dates = [];

    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];

    var currDate = moment(start).startOf('day');
    var lastDate = moment(end).startOf('day');

    var startDay = currDate.format('DD'),
      startMonth = parseInt(currDate.format('MM')),
      startYear = currDate.format('YYYY');

    if (dateRange != 3) {
      dates.push(startDay + months[startMonth - 1] + startYear);
    }

    while (currDate.add(1, 'days').diff(lastDate) < 0) {
      var temp = currDate.clone();
      var day = temp.format('DD'),
        month = parseInt(temp.format('MM')),
        year = temp.format('YYYY');

      dates.push(day + months[month - 1] + year);
    }

    if (dateRange != 1) {
      var endDay = lastDate.format('DD'),
        endMonth = parseInt(lastDate.format('MM')),
        endYear = lastDate.format('YYYY');
      dates.push(endDay + months[endMonth - 1] + endYear);
    }

    return dates;
  }

  $('#search_page_100026 input[type="submit"]').on('click', function(e) {
    if ($('#filter-from').length < 1 && $('#filter-to').length < 1) {
      $('from#search_page_100026').submit();
    } else {
      var from = $('#filter-from').val(),
        to = $('#filter-to').val(),
        temp_startDate = from,
        temp_toDate = to;

      if (from.length > 0 && to.length > 0) {
        var temp = from.split('/');
        from = new Date(temp[2], temp[1] - 1, temp[0]);

        temp = to.split('/');
        to = new Date(temp[2], temp[1] - 1, temp[0]);

        if (from > to) {
          $('.article-list .date__error').removeClass('hidden');
          e.preventDefault();
        } else {
          var dates = getDates(from, to, 365).join('|');

          if ($('#queries_daterange_query').length > 0) {
            $('#queries_daterange_query').val(dates);
          } else if ($('#queries_date_mediarelease_query').length > 0) {
            $('#queries_date_mediarelease_query').val(dates);
          }

          sessionStorage.setItem('startDate', temp_startDate);
          sessionStorage.setItem('toDate', temp_toDate);

          $('from#search_page_100026').submit();
        }
      }
    }
  });

  function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  //event search
  var dateRangeParam = getUrlParameter('queries_date_range_query');
  if (dateRangeParam != undefined && dateRangeParam.length != 0) {
    var dates = dateRangeParam.split('|');
    $('.filter__radiobuttons-item input').removeClass('checked');

    var months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    var info = '';
    if (dates.length == 1) {
      var singleDate = dates[0];

      var dateObj = new Date();
      var day = dateObj.getDate(),
        month = months[parseInt(dateObj.getMonth())],
        year = dateObj.getFullYear();
      var today = day + month + year;
      if (singleDate == today) {
        selectDateRangeRadio('filter-daterange-1');
      } else {
        day = singleDate.slice(0, 2);
        month = months.indexOf(singleDate.substring(2, singleDate.length - 4));
        year = singleDate.slice(-4);

        var dateToSet = new Date(year, month, day);

        setTimeout(function() {
          $('.js-datepicker').datepicker('setDate', dateToSet);
        }, 500);
      }
    } else if (dates.length == 3) {
      selectDateRangeRadio('filter-daterange-3');
    } else if (dates.length == 7) {
      selectDateRangeRadio('filter-daterange-7');
    } else if (dates.length >= 28) {
      selectDateRangeRadio('filter-daterange-30');
    }
  }

  function selectDateRangeRadio(id) {
    var idSelector = '#' + id;
    $(idSelector)
      .prop('checked', true)
      .addClass('checked');
  }

  var inputParam = getUrlParameter('queries_search_kw_query');
  var categoryParam = getUrlParameter('queries_category_query');
  var dateRange = getUrlParameter('queries_daterange_query');
  var dateMedia = getUrlParameter('queries_date_mediarelease_query');
  var scrollTo = false;

  if (
    (dateRangeParam != undefined && dateRangeParam != '') ||
    (dateMedia != undefined && dateMedia != '')
  ) {
    $(
      '.filter__content.js-filter-content, .filter__title.js-filter-title'
    ).addClass('active');
    scrollTo = true;
  } else if (inputParam != undefined && inputParam != '') {
    $('.js-filter-title button').trigger('click');
    scrollTo = true;
  } else if (categoryParam != undefined && categoryParam != '') {
    $('.js-filter-title button').trigger('click');
    scrollTo = true;
  } else if (dateRange != undefined && dateRange != '') {
    $('.js-filter-title button').trigger('click');
    scrollTo = true;
  }

  setTimeout(function() {
    if (scrollTo) {
      $('html, body').animate(
        {
          scrollTop:
            $('.article-list').offset().top - $('.header').height() + 'px'
        }
        
      );
    }
  }, 300);

  //content listing page
  if ($('.js-listing-page').length == 1) {
    if (typeof availableCategories != 'undefined') {
      if (availableCategories.length > 0) {
        availableCategories = availableCategories.replace(/\s+/g, '');
        var categories = availableCategories.split(';');

        $('#queries_category_query option').each(function() {
          var optionVal = $(this).val();
          if (optionVal.length > 0) {
            var temp1 = optionVal.split('-');
            var prefix = temp1[0];
            if ($.inArray(prefix, categories) < 0) {
              $(this).remove();
            }
          }
        });
      }
    }
  }
})(jQuery);

/*  apply from Date and to Date to calander after search*/
$(document).ready(function() {
  const fromDate = sessionStorage.getItem('startDate'),
    toDate = sessionStorage.getItem('toDate');

  if ($('#search_page_100026').length != 1) {
    sessionStorage.removeItem('startDate');
    sessionStorage.removeItem('toDate');
  }

  // check if date range valid
  if (
    (fromDate != '' && fromDate != null) ||
    (toDate != '' && toDate != null)
  ) {
    const newFromDate = fromDate.split('/'),
      newToDate = toDate.split('/');
    //check if on content listing page;
    if ($('#search_page_100026').length == 1) {
      // apply date value to calendar after page reload;
      $('#filter-from').datepicker(
        'setDate',
        new Date(newFromDate[2], newFromDate[1] - 1, newFromDate[0])
      );
      $('#filter-to').datepicker(
        'setDate',
        new Date(newToDate[2], newToDate[1] - 1, newToDate[0])
      );

      //keep search box open after page reload;
    } else {
      sessionStorage.removeItem('startDate');
      sessionStorage.removeItem('toDate');
    }
  } else {
    return;
  }
});
